import Pusher from 'pusher-js'
import Cookies from 'universal-cookie'
import {markActivity, Member} from './redux/members'
import {useAppDispatch} from './redux/configureStore'
import {useAuth} from './components/AuthProvider'
import {useCallback} from 'react'

const cookies = new Cookies()

const PusherChannels = {
  presenceOrgChannel: (orgId: number) => `presence-org-${orgId}`,
}

export const usePusherSubscribe = () => {
  const dispatch = useAppDispatch()
  const auth = useAuth()

  const subscribeToPusher = useCallback(
    (member: Member) => {
      const pusher = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY ?? '', {
        cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER ?? '',
        channelAuthorization: {
          endpoint:
            process.env.REACT_APP_BKS_PLATFORM_SERVICES_URL +
            '/v1/are/pusher/auth',
          headers: {
            Authorization:
              'Bearer ' +
              cookies.get(
                process.env.REACT_APP_TOKEN_NAME || 'local_bks_token',
              ),
          },
          transport: 'ajax',
        },
        forceTLS: true,
      })

      const channel = pusher.subscribe(
        PusherChannels.presenceOrgChannel(
          member.groupAccounts
            ? member.groupAccounts[0].organizationId ?? 0
            : 0,
        ),
      )

      channel.bind('pusher:subscription_succeeded', function () {
        dispatch(markActivity({auth}))
      })

      // Return the pusher instance in case you need to unsubscribe or perform other actions
      return pusher
    },
    [dispatch, auth],
  )

  return subscribeToPusher
}
